import { Container, Row, Col, Card, ListGroup } from 'react-bootstrap'; 
import TypeAnimation from 'react-type-animation';
import YouTube from 'react-youtube';

export default function Appearances() {
	return(
		<Container id="appearances" className="mb-5">
		  	<TypeAnimation
			    cursor={false}
			    sequence={[ 
			       'Public Appearances', 1000, 
			       'Interviews', 1000, 
			       'Guesting', 1000, 
			       'Podcasts', 1000, 
			       'Appearances', 1000]}
			    wrapper="p"
			    className="about-me-label mt-1 text-center"
		    />

		    <Row>
		    	<Col lg={7} xs={12} md={7}>
				    <YouTube 
				    	videoId={"s51DPm4TkBc"} 
				    	id="utube-vid"
				    	title={`Zuitts Podcast Episode 1: 
		    				How Zuitt can help you transition to a tech career`} 
				    />
		    	</Col>
		    	<Col lg={5} xs={12} md={5}>
		    		<Card>
		    			<Card.Header id="appearance-label">
		    				Zuitt Podcast Episode 1: 
		    				How Zuitt can help you transition to a tech career
		    			</Card.Header>
	    				<ListGroup className="list-group-flush">
	    				     <ListGroup.Item>
	    				     	<Card.Subtitle 
	    				     		className="mt-1 mb-1"
	    				     		id="appearance-sublabel"
								>
	    				     	   Upload Date:
	    				     	</Card.Subtitle>
	    				     	<Card.Text id="appearance-data">
	    				     		August 3, 2022
	    				     	</Card.Text>
	    				     </ListGroup.Item>
	    				     <ListGroup.Item>
	    				     	<Card.Subtitle 
	    				     		className="mt-1 mb-1"
	    				     		id="appearance-sublabel"
								>
	    				     	   Description:
	    				     	</Card.Subtitle>
	    				     	<Card.Text id="appearance-data">
	    				     		Pilot episode for Zuitt's podcast series, Zuitt Bootcamp Guide. In this episode sir Jino and myself share our experiences being a Zuitt bootcamper, and describe other services provided by Zuitt. this podcast episode is powered by Zuitt Coding Bootcamp.
	    				     	</Card.Text>
	    				     </ListGroup.Item>
	    				     <ListGroup.Item>
	    				     	<Card.Subtitle 
	    				     		className="mt-1 mb-1"
	    				     		id="appearance-sublabel"
								>
	    				     	   Main Appearances:
	    				     	</Card.Subtitle>
	    				     	<Card.Text id="appearance-data">
	    				     		Marty Miguel and Ryan Joseph Yumul
	    				     	</Card.Text>
	    				     </ListGroup.Item>
	    				</ListGroup>	
		    		</Card>
		    	</Col>
		    </Row>
		</Container>
	);
};